import { useEffect, useState } from 'react';
import { ReactComponent as DeleteIcon } from '@/assets/img/v2/delete.red-icon.svg';

import './PetSetting.scss';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { Form } from 'react-bootstrap';
import { Loader } from '@/components/Loader/Loader';
import ConfirmationDialogV2 from '@/components/ConfirmationDialog/ConfirmationDialogV2';
import { useDeletePet } from '../api/deletePet';
import { useNavigate } from 'react-router';
import { useUpdatePet } from '../api/updatePetSettings';
import { Pet } from '../types';
import { PetDetail } from './PetDetail';
import { useTranslation } from 'react-i18next';
type PetSettingProps = {
  petId: number;
  petDetail: Pet;
};
export const PetSettings = ({ petId, petDetail }: PetSettingProps) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const deletePetMutation = useDeletePet();
  const updatePetMutation = useUpdatePet();
  const [allowNotifications, setAllowNotifications] = useState<boolean>(false);
  const [showDeletePetConfirmation, setShowDeletePetConfirmation] = useState<boolean>(false);
  useEffect(() => {
    const petDetailCopy: any = petDetail as any;
    if (petDetailCopy.petSetting) {
      setAllowNotifications(petDetailCopy.petSetting.allowNotifications);
    }
  }, []);

  const onConfirmPetDelete = async () => {
    setShowDeletePetConfirmation(false);
    const res = await deletePetMutation.mutateAsync({
      petId: petId ? petId + '' : '',
    });
    navigate('/my-pet-profiles');
  };

  const updatePetSettings = async () => {
    const res = await updatePetMutation.mutateAsync({
      data: {
        petId: petId ? petId : 0,
        allowNotifications: allowNotifications,
      },
    });
  };
  return (
    <div className="pet-settings tab-content">
      <div>
        <div className="setting petsked-form">
          <PetskedTitle
            size="sm"
            title={t("Notification")}
            description={t("Allow alerts and push notifications for this pet")}
            alignText="left"
          />
          <Form.Check // prettier-ignore
            type="switch"
            id="call-notification"
            checked={allowNotifications}
            onChange={(e) => setAllowNotifications(e.target.checked)}
          />
        </div>
        <hr />
        <div className="setting wrap">
          <PetskedTitle
            size="sm"
            title={t("Delete Pet")}
            description={t("Deleting this pet will also remove all its data and scheduled appointments")}
            alignText="left"
          />
          <button
            className="petsked-button button-light icon"
            onClick={() => setShowDeletePetConfirmation(true)}
          >
            {deletePetMutation.isLoading ? (
              <Loader text="deleting..." />
            ) : (
              <>
                <span>
                  <DeleteIcon />
                </span>{' '}
                <span>{t('Delete')}</span>
              </>
            )}
          </button>
        </div>
      </div>
      <div className="action">
        <button className="petsked-button button-dark" onClick={updatePetSettings}>
          {updatePetMutation.isLoading ? <Loader /> : <span>{t('Update Pofile')}</span>}
        </button>
      </div>
      <ConfirmationDialogV2
        title={t('Remove Pet?')}
        description={t('Do you really want to remove the pet?')}
        yesButtonLabel={t("Yes, Confirm")}
        noButtonLabel={t("No, Not Now")}
        onCancel={() => setShowDeletePetConfirmation(false)}
        onConfirm={onConfirmPetDelete}
        open={showDeletePetConfirmation}
      >
        <></>
      </ConfirmationDialogV2>
    </div>
  );
};
